import axios from '../../utils/axiosConfig';

import { handleLogout } from "../../clients/components/Header/AgentHeader";



export default function AgentAuthService() {
  
  const getAgent = () => axios.get(`/api/v1/clients/clients/get_agent.json`)
    .then(({ data: agentData }) => {

      if (agentData
        && Object.keys(agentData).length > 0
        && Object.getPrototypeOf(agentData) === Object.prototype) {
        localStorage.setItem('agent', JSON.stringify(agentData));
        localStorage.setItem('agentLoginDate', Date());
        return agentData;
      }
      console.log('agentData is empty');
      return null;
    })
    .catch((error) => {
      handleLogout();
    });


  

  const loginAgent = (values) => axios.post('/api/v1/clients/agents/sign_in', {
    'agent_login': values
  }).then(({ data }) => data);


  const signUpAgent = (data) => axios.post('/api/v1/clients', {
    agent: data
  }).then(({ data }) => data);

  return {
    getAgent,
    loginAgent,
    signUpAgent
  };
}
